import { OrderingInitialState, SelectCustomerPhoneNumberAction } from '@reducers/ordering/types';

export const setCustomerPhoneNumber = (
  state: OrderingInitialState,
  action: SelectCustomerPhoneNumberAction
): OrderingInitialState => ({
  ...state,
  customerState: {
    ...state.customerState,
    phoneNumberForNewCustomer: action.payload,
  },
});
